@let isPlainValue = isPlain();
@let stateValue = state();
@let offerValue = offer();
@let hasPublishActionsValue = hasPublishActions();

<rt-button
  [variant]="isPlainValue ? 'plain' : 'outline'"
  #statusDropdownTrigger="rtOverlayOrigin"
  (click)="openStatusDropdown(statusDropdown)"
  [dropdownVisible]="!isPlainValue"
  [dropdownOpened]="statusDropdown.open"
  rt-overlay-origin
  [class.pointer-events-none]="stateValue !== 'default'"
  margin-left-small-x
>
  <rt-offer-status [status]="offerValue.status" [offerStatus]="offerValue.status">
  </rt-offer-status>
</rt-button>

<ng-template
  (backdropClick)="statusDropdown.open = false"
  [origin]="statusDropdownTrigger"
  #statusDropdown="rtConnectedOverlay"
  rt-connected-overlay
  hasBackdrop
>
  <rt-dropdown class="statuses-dropdown" [width]="DropdownWidth.Medium">
    <rt-dropdown-header (click)="$event.preventDefault()">
      {{ 'app.offers.offer_status' | translate }}
    </rt-dropdown-header>
    @if (hasPublishActionsValue) {
      <rt-dropdown-item
        [isSelected]="offerValue.status === OfferStatus.Published"
        (click)="changeStatus(StatusChangeType.Publish)"
      >
        <rt-offer-status status="published" [offerStatus]="offerValue.status"> </rt-offer-status>
      </rt-dropdown-item>
    }
    @if (hasPublishActionsValue) {
      <rt-dropdown-item
        [isSelected]="offerValue.status === OfferStatus.Internal"
        (click)="changeStatus(StatusChangeType.Unpublish)"
      >
        <rt-offer-status status="internal" [offerStatus]="offerValue.status"> </rt-offer-status>
      </rt-dropdown-item>
    }
    <rt-dropdown-item
      [isSelected]="offerValue.status === OfferStatus.Closed"
      (click)="changeStatus(StatusChangeType.Close)"
    >
      <rt-offer-status status="closed" [offerStatus]="offerValue.status"> </rt-offer-status>
    </rt-dropdown-item>
    <rt-dropdown-item
      [isSelected]="offerValue.status === OfferStatus.Archived"
      (click)="changeStatus(StatusChangeType.Archive)"
    >
      <rt-offer-status status="archived" [offerStatus]="offerValue.status"> </rt-offer-status>
    </rt-dropdown-item>
  </rt-dropdown>
</ng-template>
